<script lang="ts" setup>
</script>

<template>
  <div v-once>
    <div class="document-page">
      <h2 class="document-title">OpenAtom Foundation Website Terms of Use</h2>
      <div class="document-date">(Updated on February 28, 2022)</div>
      <p>
        When any network user (hereinafter referred to as "You") aaccesses,
        browses and uses the OpenAtom Foundation website (hereinafter referred
        to as this "Website") in any form, You should apply all the following
        terms:
      </p>
      <h5>1. Terms of Use</h5>
      <p>
        By accessing and using this Website, You agree to these Terms of Use; if
        You do not agree to these Terms of Use, please stop accessing and using
        this Website. To the extent permitted by law, this Website reserves the
        right to change the content of these Terms of Use at any time at its
        sole discretion, for which You are responsible for periodically checking
        the changes to these Terms of Use. If You continue to use this Website
        after the release of information about changes to these Terms of Use,
        You will be deemed to agree to and accept such changes.
      </p>
      <h5>2. Website Information and Description</h5>
      <p>
        This Website is managed and operated within the territory of the
        People's Republic of China. Despite being globally accessible, not all
        the functions, contents or services posted, discussed, provided or
        offered through or on this Website are available to or in locations. If
        You choose toaccess this Website from a country or region outside of
        China, You do so at your own risk and are in charge of complying with
        any applicable local laws in that location.
      </p>
      <h5>3. Website Content</h5>
      <p>
        All the texts, images, sounds, videos, animations, trademarks, graphics,
        diagrams, visual interfaces and computer codes (hereinafter collectively
        referred to as "Contents") contained onin this Website, including but
        not limited to their creative ideas, design, structures, manifestation
        modes, presentation outcomes, and other aspects, are completely owned
        and controlled by this Website or used with the legal authorization from
        this Website. Except as expressly permitted in these Terms of Use, You
        may not use the Contents of this Website in any way for any commercial
        purpose without the prior written consent of OpenAtom Foundation. You
        are permitted to download information from this Website relating to
        Contents and services , provided that the following conditions have been
        satisfied:
      </p>
      <ul>
        <li>
          (1) using such information only for personal purposes, rather than
          commercial purposes;
        </li>
        <li>(2) making no change to such information;</li>
        <li>
          (3) making no further representation and warranty for such information
          and the documents containing it;
        </li>
        <li>
          (4) not removing any statement or notification indicating the
          ownership as well as other legal rights and interests of this Website.
        </li>
      </ul>
      <h5>4. Usage Rules</h5>
      <p>
        You shall not use this Website for any illegal purpose or any purpose
        prohibited by these Terms of Use, nor shall You use this Website and its
        Contents to infringe the legal rights and interests of other
        organizations or individuals. You shall not access, obtain, copy or
        monitor any part or any Content of this Website by using any form of
        device, program, algorithm, or any identical or similar manual program,
        including crawlers, Robot protocols, deep linking or web scraping, nor
        shall You access, obtain or reproduce any material, document or
        information posted on this Website by any means other than those as
        provided by this Website. You shall not attempt to access any Content of
        this Website or use any services provided on this Website without
        authorization by trespassing, password cracking or using any other
        illegal means. You shall not trace, reverse lookup, crack or decipher
        any customer information on this Website, including but not limited to
        any account registered on this Website that is not held by You. You
        shall not violate any network security mechanism or authentication
        measures of this Website or any website linking to this Website, nor
        shall You detect, scan or test any network vulnerability of this Website
        or any website linking to this Website, or launch any form of
        cyber-attack against this Website. You agree not to use any device,
        software or program to interfere or attempt to interfere with the
        regular operation of this Website or any transactions conducted on this
        Website, or interfere or attempt to interfere with the use of this
        Website by other individuals. You shall not take any action to store an
        unreasonably or disproportionately mass of data on the infrastructure,
        system or network of this Website, or the systems or networks linking to
        this Website.
      </p>
      <h5>5. Account, Password and Security</h5>
      <p>
        You may need to register/log into your account first to access certain
        functions or services provided by this Website. You are fully
        responsible for keeping the confidentiality of your account information
        (including but not limited to your account password, etc.); in addition,
        You shall be fully responsible for any and all actions that occur under
        your account as a result of your failure to keep the security and
        confidentiality of your information. In the event that You find any
        unusual activity on your account (including but not limited to password
        tampering, unauthorized login or usage by others, etc.), You shall
        notify this Website immediately. If You fail to keep the confidentiality
        of your account information, which causes your account on this Website
        to be used by others and thereby result in losses to this Website or
        other users of this Website, You may be liable for compensating for such
        losses. You shall never use another person’s account on this Website
        without the express permission and consent of the account holders of
        this Website. This Website is not responsible for any loss incurred by
        You or others as a result of your breach of this Clause’s requirements.
      </p>
      <h5>6. External Links</h5>
      <p>
        This Website may contain links to other independent third-party
        websites; these links are only provided for the convenience of this
        Website’s users in accessing those websites. This Website does not
        provide any express or implied warranties for the content, services,
        information and other aspects of the linked websites, and such links do
        not mean that this Website endorses or authorizes such linked websites.
        You need to make your own independent judgment in your own discretion
        with the aforesaid linked websites, for which this Website disclaims any
        responsibility.
      </p>
      <h5>7. Privacy</h5>
      <p>
        The privacy policy of this Website shall be applicable to the user
        behaviors of this Website, the details of which could be checked in
        "Privacy Policy" at the bottom of each webpage. The "Privacy Policy"
        aims to help You understand what kinds of information the Website of
        OpenAtom Foundation collects, why it does so, and how it uses, accesses,
        modifies, discloses and deletes your personal information. Please take
        note that You are aware and agree that the network connection and data
        transmission between You and this Website is not absolutely secure or
        confidential, that the information and data you send to this Website may
        be intercepted by others, and that this Website cannot guarantee the
        security and privacy of any information and data You provide to this
        Website.
      </p>
      <h5>8. Reservation of Rights</h5>
      <p>
        This Website reserves the right to perform the following actions at any
        time without notification:
      </p>
      <ul>
        <li>
          (1) suspending or terminating the operation and access of this Website
          in whole or in part for any reason;
        </li>
        <li>
          (2) modifying or changing all or partial Contents of this Website as
          well as its applicable policies or terms;
        </li>
        <li>
          (3) interrupting the operation and access of this Website in whole or
          in part when necessary for regular or non-scheduled maintenance, error
          correction or other changes in circumstances, etc.
        </li>
      </ul>
      <h5>9. Disclaimer</h5>
      <p>
        This Website and its Contents are provided on an "AS IS" basis. Although
        this Website intends to provide information as accurate as possible and
        services as convenient as possible, OpenAtom Foundation provides no
        warranty, in any form, on the ownership, availability, continuity,
        accessibility, correctness, completeness, reliability, timeliness,
        non-infringement of intellectual property rights and third-party rights
        of the Contents and services contained in this Website. You shall take
        full responsibility for your use of this Website and any linked website.
        If You are dissatisfied with the entire or partial Contents of this
        Website, the sole remedy for You is to stop using this Website in whole
        or in part, and such remedy limitations constitute a part of the
        agreement between You and this Website.
      </p>
      <h5>10. Limitation of Liability</h5>
      <p>
        EXCEPT AS PROHIBITED BY APPLICABLE LAW, IN NO EVENT WILL THIS WEBSITE BE
        LIABLE TO YOU FOR ANY INDIRECT, INCIDENTAL OR PUNITIVE DAMAGES RELATED
        TO ANY USE OF THIS WEBSITE, THE CONTENTS, OR ON ANY OTHER LINKED
        WEBSITE, INCLUDING BUT NOT LIMITED TO ANY LOST PROFITS, EVEN IF THIS
        WEBSITE IS AWARE OF THE POSSIBILITY OF SUCH DAMAGE OR LOSS. THE FULL OR
        MAXIMUM LIABILITY OF OPENATOM FOUNDATION AND ITS PARTNERS FOR ANY
        DAMAGES OR LOSSES ARISING FROM YOUR USE OF THIS WEBSITE SHALL IN NO
        EVENT EXCEED THE TOTAL AMOUNT OF SUBSCRIPTION FEES OR SIMILAR FEES
        RELATING TO YOUR USE OF ANY SERVICE OR FUNCTION OF THIS WEBSITE. SOME
        JURISDICTIONS DO NOT ALLOW LIMITATION OF LIABILITY, SO THE FOREGOING
        LIMITATION MAY NOT APPLY TO YOU.
      </p>
      <h5>11. Indemnification</h5>
      <p>
        You agree to indemnify and hold OpenAtom Foundation, its directors,
        senior officers, employees, agencies, partners, agents and licensors,
        harmless from damages caused by any request, loss, liability, claim or
        expense (including attorney's fees), made against OpenAtom Foundation by
        any third party arising out of or in connection with your use of this
        Website.
      </p>
      <h5>12. Independent Remedies</h5>
      <p>
        The stipulations of Article 10 - "Limitation of Liability" and Article
        11 - "Indemnification" of these Terms of Use shall take effect
        respectively and independently (even if it is identified as unable to
        achieve its basic purpose or be enforced according to law). To the
        extent permitted by the relevant applicable law, the limitations of
        legal liabilities as specified in Articles 10 and 11 shall apply
        regardless of whether the losses are caused by the following reasons:
      </p>
      <ul>
        <li>(1) breach of contract;</li>
        <li>(2) violating warranties;</li>
        <li>(3) fault or tort, including negligence and misrepresentation;</li>
        <li>(4) strict liability;</li>
        <li>(5) any other reasons.</li>
      </ul>
      <h5>13. Breach of These Terms of Use</h5>
      <p>
        You agree that if this Website deems that You have breached these Terms
        of Use, this Website may terminate your access to this Website in its
        sole discretion and without prior notice. OpenAtom Foundation takes no
        liability to You or any third party for the termination by this Website
        of your access to this Website due to any breach of these Terms of Use.
        You agree that this Website may, in its sole discretion terminate your
        access to all or partial functions of this Website without prior notice
        for the following reasons, including but not limited to:
      </p>
      <ul>
        <li>
          (1) requests from law enforcement agencies or other government
          agencies;
        </li>
        <li>
          (2) being at your request (if You request to delete your account, then
          certain functions may be not available any more);
        </li>
        <li>
          (3) suspension or material alteration of this Website or any service
          provided by this Website; or
        </li>
        <li>(4) unexpected technical problems.</li>
      </ul>
      <h5>14. Governing Law and Jurisdiction</h5>
      <p>
        The establishment, performance, interpretation and dispute resolution of
        these Terms of Use shall be governed by the laws of the People’s
        Republic of China without reference to principles of conflicts of law.
        The signing place of these Terms of Use is Haidian District, Beijing.
        Any dispute between the Parties concerning the content or performance of
        these Terms of Use, the Parties shall endeavor to resolve such dispute
        through amiable negotiations firstly; in case such dispute fails, either
        Party may bring a lawsuit to the people's court with jurisdiction where
        these Terms of Use are signed.
      </p>
      <h5>15. Miscellaneous</h5>
      <p>
        These Terms of Use constitute the basic agreement between You and
        OpenAtom Foundation concerning your use of this Website, and unless
        otherwise stipulated in other agreements signed between You and OpenAtom
        Foundation, this Website does not accept any counter-offer to these
        Terms of Use, and hereby expressly reject any and all counter-offers.
        Failure of this Website to insist on or mandatory demand strict
        performance of these Terms of Use shall not be deemed as this Website's
        waiver of any Content of these Terms of Use or the exercise of any right
        in these Terms of Use, and any conduct between this Website and You or
        any other third party shall not be deemed as an amendment to any
        provision of these Terms of Use.
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.document-page {
  width: 1200px;
  margin: 80px auto;
}

.document-page .document-title {
  color: #222;
  font-weight: 700;
  font-size: 42px;
  text-align: center;
}

.document-page .document-date {
  margin-top: 30px;
  color: #222;
  font-weight: 700;
  font-size: 18px;
  text-align: center;
}

.document-page > p {
  margin-top: 50px;
  color: #333;
  font-size: 18px;
  line-height: 28px;
}

.document-page > ul > li {
  color: #333;
  font-size: 18px;
  line-height: 28px;
}

.document-page > h5 {
  margin-top: 50px;
  color: #222;
  font-weight: 700;
  font-size: 24px;
  line-height: 150%;
}

.document-page b {
  text-decoration: underline;
}

@media (max-width: 1279.9px) {
  .document-page {
    width: auto;
    max-width: 1200px;
    padding: 0 24px;
  }
}

@media (max-width: 767.9px) {
  .document-page {
    margin: 40px auto;
    padding: 0 16px;
  }

  .document-page .document-title {
    font-size: 28px;
  }

  .document-page > p,
  .document-page > ul > li {
    font-size: 15px;
    line-height: 26px;
  }

  .document-page > h5 {
    font-size: 20px;
  }
}
</style>
